import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
	bold: {
	  fontWeight: 600
	}
  });

export default function Title(props) {
	const classes = useStyles();
	return (
		<Typography component="h2" className={classes.bold}  variant="body2" color="primary" gutterBottom>
			{props.children}
		</Typography>
	);
}

Title.propTypes = {
	children: PropTypes.node,
};
